module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0007#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0008#ch01"
    }
  }, [_vm._v("1   The Task and the Puzzle of Reason in the "), _c('i', [_vm._v("Nicomachean Ethics")]), _vm._v(" ("), _c('i', [_vm._v("NE")]), _vm._v(" 1 and 2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0009#ch02"
    }
  }, [_vm._v("2   Knowledge, Choice, and Responsibility for Character ("), _c('i', [_vm._v("N")]), _c('i', [_vm._v("E")]), _vm._v(" 3.1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0010#ch03"
    }
  }, [_vm._v("3   Reason and Purpose in the Moral Virtues ("), _c('i', [_vm._v("N")]), _c('i', [_vm._v("E")]), _vm._v(" 3.6–4.9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0011#ch04"
    }
  }, [_vm._v("4   Justice and the Rule of Reason ("), _c('i', [_vm._v("N")]), _c('i', [_vm._v("E")]), _vm._v(" 5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0012#ch05"
    }
  }, [_vm._v("5   Wisdom and Active Wisdom: The Intellectual Virtues ("), _c('i', [_vm._v("N")]), _c('i', [_vm._v("E")]), _vm._v(" 6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0013#ch06"
    }
  }, [_vm._v("6   Problems of Self-Control ("), _c('i', [_vm._v("N")]), _c('i', [_vm._v("E")]), _vm._v(" 7.1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0014#epil"
    }
  }, [_vm._v("Epilogue: The Philosophic Life ("), _c('i', [_vm._v("N")]), _c('i', [_vm._v("E")]), _vm._v(" 10.6–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0015#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0016#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0017#ch07"
    }
  }, [_vm._v("Bibliography of Modern Works and Editions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipanglereason0018#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb090e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-pangle-reason-0006.vue
// module id = 69
// module chunks = 0